export default function CourseTerms() {
    return (
        <>
            <section id="guitar-course-details-section">
                <div className="guitar-course-details-container">
                    <div className="guitar-course-details-content">
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">TRAINING INVOLVES</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Step-by-step learning of open & barre chords, advanced chord progressions.</li>
                                <li>Strumming, fingerpicking, arpeggios, and improvisation.</li>
                                <li>Scales, modes, riffs, and solo-building.</li>
                                <li>Acoustic, electric, and classical guitar styles.</li>
                                <li>Music theory, ear training, and personalized repertoire.</li>
                            </ul>
                        </div>
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Who is it For</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Absolute beginners starting their first instrument.</li>
                                <li>Hobbyists who want to play for leisure.</li>
                                <li>Intermediate and advanced players preparing for performances or certifications.</li>
                                <li>Composers and singer-songwriters seeking guitar accompaniment.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Learning Outcomes</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Confident playing across genres like rock, pop, jazz, blues, classical, and Bollywood.</li>
                                <li>Strong improvisation and solo performance skills.</li>
                                <li>Ability to compose original guitar pieces.</li>
                                <li>Readiness for graded international exams (Trinity, Rock School, ABRSM).</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 